import React, { useState, useEffect } from 'react';
import './BtnWhatsapp.css';
import whatsappIcon from '../../images/wpp.png';
import Modal from 'react-modal';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { useParams, useLocation } from "react-router-dom";

export default function BtnWhatsapp() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [contactos, setContactos] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [noteText, setNoteText] = useState('¡Hola! Estoy interesado en..');
    const { idTienda } = useParams();
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    useEffect(() => {
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse() || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const [loading, setLoading] = useState(true);
    const [tiendas, setTienda] = useState([]);

    useEffect(() => {
        cargarTiendas();

        const handleTiendaCargada = (e) => {
            if (e.detail) {
                setTienda(e.detail);
                setLoading(false);
            }
        };
        window.addEventListener('tienda-cargada', handleTiendaCargada);
        return () => window.removeEventListener('tienda-cargada', handleTiendaCargada);
    }, [idTienda]);

    const cargarTiendas = () => {
        fetch(`${baseURL}/tiendasFrontend.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (idTienda) {
                    const tienda = data.tiendas.find(t => t.idTienda === parseInt(idTienda));
                    setTienda(tienda);
                }
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const handleWhatsappMessage = () => {
        const phoneNumber = isHomePage
            ? (contactos?.length <= 1 ? contactos[0]?.telefono : selectedContact?.telefono)
            : tiendas?.telefono;

        if (phoneNumber) {
            let noteMessage = '';
            if (noteText.trim() !== '') {
                noteMessage += `\n ${noteText}`;
            }

            const message = `${noteMessage}`;
            const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

            window.open(whatsappUrl, '_blank');

            setNoteText('');
            closeModal();
        }
    };

    return (
        <div className='containWpp'>
            <button className='btnWhatsapp' onClick={openModal} aria-label="Abrir chat de WhatsApp">
                <svg
                    viewBox="0 0 448 512"
                    width="26"
                    height="26"
                    fill="currentColor"
                    aria-hidden="true"
                    className="whatsapp-floating-icon"
                >
                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                </svg>
                <strong>WhatsApp</strong>
            </button>


            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-wpp"
                overlayClassName="overlay-wpp"
            >
                <div className='containModalWpp'>
                    <div className='headerWpp'>
                        {contactos.length > 1 ? (
                            <span>Selecciona un teléfono</span>
                        ) : (
                            <span>Envíanos un mensaje</span>
                        )}
                        <button onClick={closeModal} className='closeBtn' aria-label="Cerrar modal de WhatsApp">X</button>
                    </div>

                    {isHomePage ? (
                        <div className='mensaje'>
                            <p>Hola, somos
                                {contactos?.slice(0, 1).map(item => (
                                    <> {item?.nombre}</>
                                ))}
                                <br />¿en qué podemos ayudarte? 👋
                            </p>
                        </div>
                    ) : (
                        <div className='mensaje'>
                            <p>Hola, somos {tiendas?.nombre} <br />¿En qué podemos ayudarte? 👋</p>
                        </div>
                    )}

                    <div className='btnsWpp'>
                        {isHomePage && contactos.length > 1 && (
                            contactos.map(item => (
                                <button
                                    key={item.idContacto}
                                    className='btnWpp'
                                    style={{ backgroundColor: selectedContact && selectedContact.idContacto === item.idContacto ? 'green' : '' }}
                                    onClick={() => setSelectedContact(item)}
                                    aria-label={`Escribir a WhatsApp ${item.telefono}`}
                                >
                                    {item.telefono}
                                    <img src={whatsappIcon} alt="whatsappIcon" />
                                </button>
                            ))
                        )}
                    </div>

                    <div className='sendWpp'>
                        <textarea
                            placeholder="Envíanos un mensaje"
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                        />
                        <button onClick={handleWhatsappMessage} aria-label="Enviar mensaje por WhatsApp">
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
